import $i18n from '@alife/panda-i18n';
import { CnButton, CnMessage } from '@alife/cn-ui';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { usePrintInstance } from '../print';
import { printValueAddedOrder, querySelfVasDetailList } from './api';
import StatusCard from './components/stu-card';
import { PayStatusList } from './const';
export function useTable({ asnCode, setEditRecord, handleShowServiceDialog, setCloseService, setAffirmDialogVisible, }) {
    const [tableLoading, setTableLoading] = useState(false);
    const [existedServiceType, setExistedServiceType] = useState([]);
    const [canEdit, setCanEdit] = useState(true);
    const [selfVasPayerInfo, setSelfVasPayerInfo] = useState(null);
    const [headers, setHeaders] = useState([]);
    const printInstance = usePrintInstance();
    const [selfVasDetailList, setSelfVasDetailList] = useState([]);
    // 条码打印
    const onPrint = useCallback((nowRow) => {
        const startTime = Date.now();
        printValueAddedOrder({ id: nowRow.id })
            .then((result) => {
            const { data: resData } = result;
            if (resData) {
                const endTime = Date.now();
                const { documents = [], ...extraData } = resData;
                const { responseTime = 0 } = extraData;
                const docs = [];
                documents.forEach((doc) => {
                    const { configName = '', contents = [] } = doc;
                    contents.forEach(({ data: tmpData = {}, templateCode = '', templateURL = '' }) => docs.push({
                        printConfig: {
                            configName,
                            printType: 'cloud',
                            dataSource: 'CAINIAO',
                            templateCode,
                            templateUrl: templateURL,
                            extraData: {
                                startTime,
                                endTime,
                                networkTime: responseTime + (endTime - startTime),
                                ...extraData,
                            },
                        },
                        data: [tmpData],
                    }));
                });
                docs.forEach((d) => {
                    printInstance?.doPrint([d]);
                });
            }
        })
            .catch((e) => {
            const message = e?.message || e?.code || '';
            CnMessage.error(message);
        });
    }, [printInstance]);
    /** 操作列 */
    const operateColumns = useMemo(() => {
        const buttons = [
            (rowData) => {
                if (['1'].includes(rowData.selfVasPayStatus)) {
                    return (React.createElement(CnButton, { type: 'primary', text: true, onClick: () => {
                            setEditRecord(rowData);
                            handleShowServiceDialog('edit', rowData);
                        } }, $i18n.get({ id: 'Edit', dm: '编辑' })));
                }
                return null;
            },
            (rowData) => {
                if (['1', '2', '3'].includes(rowData.selfVasPayStatus)) {
                    return (React.createElement(CnButton, { type: 'primary', text: true, warning: true, onClick: () => {
                            setCloseService(true);
                            setEditRecord(rowData);
                        } },
                        React.createElement("span", { className: 'red' }, $i18n.get({ id: 'CancelService', dm: '取消服务' }))));
                }
                return null;
            },
            (rowData) => {
                if (['1', '2', '3'].includes(rowData.selfVasPayStatus)) {
                    return (React.createElement(React.Fragment, null,
                        React.createElement(CnButton, { type: 'primary', text: true, onClick: () => {
                                setAffirmDialogVisible(true);
                                setEditRecord(rowData);
                            } }, $i18n.get({ id: 'Confirm', dm: '确认' }))));
                }
                return null;
            },
            (rowData) => {
                if (rowData.selfVasPayStatus !== '-1') {
                    return (React.createElement(React.Fragment, null,
                        React.createElement(CnButton, { type: 'primary', text: true, onClick: () => {
                                onPrint(rowData);
                            } }, $i18n.get({ id: 'PrintVoucher', dm: '打印凭证' }))));
                }
                return null;
            },
        ];
        return {
            buttons,
            width: 250,
        };
    }, [
        onPrint,
        handleShowServiceDialog,
        setAffirmDialogVisible,
        setCloseService,
        setEditRecord,
    ]);
    const handleSearch = useCallback(() => {
        setTableLoading(true);
        querySelfVasDetailList({
            asnCode,
            paging: { currentPage: 1, pageSize: 50 },
        })
            .then(({ data = {} }) => {
            const { items = [], headers: sourceHeaders = [] } = data;
            const typeList = items
                ?.filter((item) => item.selfVasPayStatus !== '-1')
                .map((item) => {
                return item.selfVasType;
            });
            const tmpCanEdit = items?.length
                ? !items?.some((item) => {
                    const payStatus = (item.selfVasPayStatus &&
                        parseFloat(item.selfVasPayStatus));
                    return payStatus > 1;
                })
                : true;
            setExistedServiceType(typeList); // 已选服务项
            setCanEdit(tmpCanEdit); // 是否待审核
            // todo
            const tmpHeaders = sourceHeaders?.map(({ width: _unuse, ...rest }) => {
                const { key } = rest;
                if (key === 'selfVasPayStatusDesc') {
                    return {
                        ...rest,
                        render: (val, rowData) => {
                            return (React.createElement(StatusCard, { stuList: PayStatusList, noValue: true, stuVal: val, record: rowData, stuCode: 'selfVasPayStatus' }));
                        },
                    };
                }
                return rest;
            });
            setHeaders(tmpHeaders);
            setSelfVasDetailList(items);
            const tmpIsDisabled = items?.[0]?.featureMap?.isServiceAppointments === '1';
            if (tmpIsDisabled) {
                setSelfVasPayerInfo({
                    isDisable: tmpIsDisabled,
                    vasSelfPayerName: items?.[0]?.selfVasPayerInfo,
                    vasSelfAccountType: items?.[0]?.selfVasAccountType,
                });
            }
            else {
                setSelfVasPayerInfo({
                    isDisable: tmpIsDisabled,
                    vasSelfPayerName: items?.[0]?.value,
                    vasSelfAccountType: items?.[0]?.vasSelfAccountType,
                });
            }
        })
            .catch((e) => {
            setExistedServiceType([]); // 已选服务项
            const message = e?.message || e?.code || '';
            CnMessage.error(message);
        })
            .finally(() => {
            setTableLoading(false);
        });
    }, [asnCode, setExistedServiceType]);
    useEffect(() => { }, []);
    return {
        handleSearch,
        selfVasDetailList,
        existedServiceType,
        tableLoading,
        headers,
        canEdit,
        operateColumns,
        selfVasPayerInfo,
    };
}
